<ng-container *transloco="let t; read: 'cookies'">
	<div class="wrapper" *ngIf="!clicked && (show || force)" [@fade]="media">
		<div class="content">
			<div class="text-wrapper">
				{{t('consent')}}
			</div>
			<app-button size="s" (click)="accept()">
				{{'buttons.accept' | transloco}}
			</app-button>
			<app-button appearance="outline" size="s" (click)="reject()">
				{{'buttons.reject' | transloco}}
			</app-button>
		</div>
	</div>
</ng-container>